import { Button, Select } from "antd";
import React, { useContext } from "react";
import { StateContext } from "../../../store/context";

type PeriodSelectorType = {
  selectedInterval: any;
  setSelectedInterval: (value: any) => void;
  selectedPeriod: any;
  setSelectedPeriod: (value: any) => void;
};
export const PeriodSelector = (props: PeriodSelectorType) => {
  const {
    selectedInterval,
    setSelectedInterval,
    setSelectedPeriod,
    selectedPeriod,
  } = props;

  const {
    baseCurrency,
    authUser: { allowed, sub_plan, role_name },
  } = useContext(StateContext);

  const intervalOptions = [
    {
      label: "Quartely",
      value: "quarterly",
    },
    {
      label: "Annualy",
      value: "annually",
    },
  ];

  const isBasicCustomer =
    sub_plan === "Free Plan" && role_name === "Basic Customer";

  const periods = [
    { label: "1Y", value: "1" },
    { label: "3Y", value: "3" },
    { label: "5Y", value: "5", disabled: isBasicCustomer },
  ];

  const handlePeriodClick = (period: any) => {
    setSelectedPeriod(period);
  };
  return (
    // No longer a standalone full-width block of its own (pt-4, !h-full
    // !w-full) — this now sits inline as one section among Stocks/
    // Parameters in the unified controls row (newDynamicGraph.tsx), so
    // Interval/Period are sized to their own content instead of
    // stretching to fill a row they no longer own alone.
    <div className="flex md:flex-row flex-col items-start md:items-center gap-y-3 md:gap-y-0 md:gap-x-4">
      <div className="flex flex-col gap-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-[color:var(--vi-text-tertiary)] font-inter">
          Interval
        </span>
        <Select
          onChange={(value, e) => setSelectedInterval(value)}
          options={intervalOptions}
          defaultValue={"quarterly"}
          placeholder="Select Interval"
          popupClassName="vi-dg-stock-popup"
          className="!w-[140px] !outline-none focus:!outline-none !h-9 !rounded-[8px]"
        />
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-[color:var(--vi-text-tertiary)] font-inter">
          Period
        </span>
        <div className="flex gap-1 rounded-[8px] !h-9 p-1">
          {periods.map((period) => (
            <button
              key={period.label}
              onClick={() =>
                !period.disabled && handlePeriodClick(period.value)
              }
              disabled={period.disabled}
              className={`vi-dg-pill px-4 !text-center !text-nowrap ${
                selectedPeriod == period.value ? "vi-dg-pill-active" : ""
              }`}
            >
              {period.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
